export default {
  component: () => import("@/layout/Layout2.vue"),
  meta: { requiresAuth: true, requiresEmitente: true },
};
